/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DeprecatedProjectIndicatorJS_project = {
    readonly name: string | null;
    readonly companyProjectId: number | null;
    readonly customProjectId: string | null;
    readonly projectColor: string | null;
    readonly " $refType": "DeprecatedProjectIndicatorJS_project";
};
export type DeprecatedProjectIndicatorJS_project$data = DeprecatedProjectIndicatorJS_project;
export type DeprecatedProjectIndicatorJS_project$key = {
    readonly " $data"?: DeprecatedProjectIndicatorJS_project$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"DeprecatedProjectIndicatorJS_project">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DeprecatedProjectIndicatorJS_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "companyProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customProjectId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "projectColor",
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
(node as any).hash = '0c04892525d87c46f0014f37dcbc2036';
export default node;
